import { createSelector } from 'redux-orm';

import orm from '../orm';

const isGlobalTemplate = (ps) =>
  ps &&
  (ps.projectId == null || ps.projectId === '') &&
  (ps.boardId == null || ps.boardId === '');

/** Глобальные шаблоны = PointSystem без project/board */
export const selectContentTypeTemplates = createSelector(orm, ({ PointSystem }) =>
  PointSystem.all()
    .toRefArray()
    .filter(isGlobalTemplate)
    .sort((a, b) => String(a.id).localeCompare(String(b.id))),
);

/** Items шаблона = ContentType выбранного global PointSystem */
export const selectContentTypeTemplateItemsByTemplateId = createSelector(
  orm,
  (_, templateId) => templateId,
  ({ ContentType }, templateId) => {
    if (!templateId) {
      return [];
    }

    const id = String(templateId);

    return ContentType.all()
      .toRefArray()
      .filter((item) => String(item.pointSistemId) === id)
      .sort((a, b) => (a.sort || 0) - (b.sort || 0));
  },
);

export const selectContentTypesForPointSystem = createSelector(
  orm,
  (_, pointSystemId) => pointSystemId,
  ({ ContentType }, pointSystemId) => {
    if (!pointSystemId) {
      return [];
    }

    const id = String(pointSystemId);

    return ContentType.all()
      .toRefArray()
      .filter((item) => String(item.pointSistemId) === id)
      .sort((a, b) => (a.sort || 0) - (b.sort || 0));
  },
);

export default {
  selectContentTypeTemplates,
  selectContentTypeTemplateItemsByTemplateId,
  selectContentTypesForPointSystem,
};
